var config = require('../config');
var $ = require('jquery');
window.$ = window.jQuery = $;
window.isIframe = false;

var utils = require('./utils');

function init() {
  if(window.isOldBrowser) {
    $('html').addClass('old-browser');
    $('.fallback-image').attr('src', config.fallback.fallbackImage);
  }
  
  if(window.innerWidth > 768){
    $('body').css('overflow', 'visible')
  }
  
  utils.addHelperClasses();
  
  var csvParser = require('d3-dsv').dsvFormat(',');
  //add jquery plugins
  require('./vendor/jquery.visible');
  require('./vendor/jquery.tapevent');
  require('./vendor/jquery.resize');
  require('lazyloadxt/dist/jquery.lazyloadxt.extra');
  
  //initialize custom modules
  // require('./embed').init();
  require('./general').init();
  // require('./media').init();
  // require('./utils/social').init();
  
  var search = require('./search');
  var map = require('./map');
  var tableCreator = require('./table');
  
  
  $.get('data/data.csv').then(function(data){
    var parsedData = csvParser.parse(data);
  
    parsedData.forEach(function(el){
      el.pop = +el['value'];
      el.name = el['name'];
      el.country_de = el['sub'];
      el.dist = +el['value2'];
      el.dist_rang = +el['value2_rang'];
      el.pop_rang = +el['value_rang'];
  
      var latlng = convertCoordinate(el.latlng)
  
      el.latitude = latlng[0];
      el.longitude = latlng[1];
      
      el.formattedPop = utils.numberFormat(el.pop);
      el.formattedDist = utils.numberFormat(el.dist);
    });
  
    var sortedData = parsedData.sort(utils.sortData('pop'));
    
    sortedData.forEach(function(el, i){
      el.rank = i + 1;
    });
  
    search.init(parsedData);
    map.init(parsedData);
    tableCreator.init(parsedData);
  });
  
  function convertCoordinate(coords){
    return coords.split(',');
  }
}

export default {
  init
};
